export const TechSupport = () => (
    <div style={{
      width: '100%',
      height: '1.30rem',
      overflow: 'hidden',
      marginTop: '.20rem',
    }}>
      <img 
        src="//cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/tec-support-new.png"
        style={{
          width: '100%',
          height: '100%',
        }}
        />
    </div>
)


// WEBPACK FOOTER //
// ./src/common/tech-support/TechSupport.jsx